export const BACKEND_URL = "https://api.pixing.ai/api";